import agent from './agent'

export const Competition = {
	getCompetition: async (lineId) => {
		return new Promise((resolve, reject) => {
			return agent.Request.get(`/firestoreSchool/competition`)
				.then(response => resolve(response))
		})
	},
}